import type { ReactNode } from 'react';

import * as styles from './TableEmptyWrapper.module.scss';

type Props = {
  columns: number;
  children: ReactNode;
};

function TableEmptyWrapper({ columns, children }: Props) {
  return (
    <tr>
      <td colSpan={columns} className={styles.tableEmptyWrapper}>
        <div className={styles.content}>
          {/* Per design requirement, the empty placeholder should have a top and bottom spacing, and the space height aspect ratio is 2:3. */}
          <div className={styles.topSpace} />
          {children}
          <div className={styles.bottomSpace} />
        </div>
      </td>
    </tr>
  );
}

export default TableEmptyWrapper;
